import type ConnectionInterface from '@/api/connection/ConnectionInterface.ts';
import type {Router} from 'vue-router';
import {createApp} from 'vue';
import {createHead} from '@vueuse/head';
import {createPinia} from 'pinia';
import {initSentry} from '@/helpers/sentry.ts';
import LelkeszApp from '@/LelkeszApp.vue';
import {useTabReload} from '@/helpers/tab-reload.ts';
import {initMatomo} from '@/helpers/matomo.ts';

export function createLelkeszApp(router: Router) {
  const lelkeszApp = createApp(LelkeszApp);

  const allowedEnvs = ['live', 'staging', 'demo'];
  if (allowedEnvs.includes(import.meta.env.VITE_ENV)) {
    initSentry(lelkeszApp, router);
    initMatomo(lelkeszApp, router);
  }

  lelkeszApp.use(createPinia());
  lelkeszApp.use(router);
  lelkeszApp.use(createHead());

  lelkeszApp.mount('#app');
  useTabReload().onAppMounted();

  return lelkeszApp;
}

export async function prepareRouter(api: ConnectionInterface, router: Router) {
  const config = await api.getConfig();
  const homepage = config.site.homepage ?? 'search';

  const home = router.getRoutes().find((route) => {
    return route.path == '/';
  });
  const selectedRoute = router.getRoutes().find((route) => {
    return route.name === homepage;
  });
  if (selectedRoute && !home) {
    router.addRoute({
      ...selectedRoute,
      alias: ['/'],
    });
  }

  return router;
}
